import type React from 'react'

import {Avatar, Stack, Text} from '@primer/react-brand/esm'
import type {Person} from '../../lib/types/contentful'

type ProfileCardProps = {
  person: Person
}

const ProfileCard: React.FC<ProfileCardProps> = ({person}) => {
  const {fullName, photo, position} = person.fields

  if (!fullName) {
    return null
  }

  const avatarAlt = photo?.fields.description || fullName

  return (
    <Stack direction="horizontal" padding="none">
      {photo ? <Avatar src={photo?.fields.file.url || ''} alt={avatarAlt} size={48} /> : null}
      <Stack gap={4} padding="none">
        <Text size="100">{fullName}</Text>
        {position ? (
          <Text size="100" variant="muted">
            {position}
          </Text>
        ) : null}
      </Stack>
    </Stack>
  )
}

export default ProfileCard
